import { useQuery } from '@tanstack/react-query';
import { sparkActivityOverviewApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ActivityOverviewStatus } from '../types/activity-overview';

export function useActivityOverview(status: ActivityOverviewStatus) {
  return useQuery({
    queryKey: queryKeys.sparkActivities.overview(status),
    queryFn: () => sparkActivityOverviewApi.getOverview(status),
    staleTime: 60 * 1000,
  });
}
